import React, { useMemo } from 'react';
import { Divider, Input, View, createStyleSheet, useStyleSheet } from '@gopeerproject/ui-kit';
import { FlatList } from 'react-native';
import { InsetLines, Item } from '.';
export const List = ({ flatList, renderItem, search, searchable, setSearch, wide, placeholder = '', style, onItemPress, multiple, selected }) => {
    const styles = useStyleSheet(getStyles);
    renderItem = useMemo(() => renderItem !== null && renderItem !== void 0 ? renderItem : ((props) => React.createElement(Item, Object.assign({}, props))), [renderItem]);
    return (React.createElement(View, { style: [styles.dropdown, wide && styles.dropdown__wide, style] },
        searchable && (React.createElement(Input, { style: styles.search, value: search, onChange: (v) => {
                setSearch(v);
            }, placeholder: placeholder, icon: 'search' })),
        React.createElement(FlatList, { style: [
                styles.dropdownScrollView,
                wide && styles.dropdownScrollView__wide,
                searchable && styles.dropdownScrollView__searchable
            ], ItemSeparatorComponent: (props) => props.leadingItem.dividerAfter ? (React.createElement(Divider, { type: 'horizontal', style: styles.divider })) : null, renderItem: ({ item, index }) => (React.createElement(View, { style: styles.itemWrapper },
                React.createElement(InsetLines, { item: item, index: index, flatList: flatList }),
                renderItem({
                    item,
                    onPress: 'value' in item ? onItemPress(item.value) : undefined,
                    selected: 'value' in item &&
                        (multiple
                            ? selected === null || selected === void 0 ? void 0 : selected.includes(item.value)
                            : selected === item.value)
                }))), data: flatList, keyExtractor: (item) => ('value' in item ? item.value : item.label) })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    dropdown: {
        position: 'absolute',
        zIndex: 9,
        backgroundColor: color.bg.v3,
        borderRadius: size.G,
        width: 260,
        top: 'calc(100% + 8px)',
        boxShadow: '0px 8px 42px rgba(28, 29, 40, 0.1)'
    },
    dropdown__wide: { width: 400 },
    search: { margin: size.C },
    dropdownScrollView: {
        maxHeight: 400,
        padding: size.C
    },
    dropdownScrollView__searchable: { paddingTop: 0 },
    dropdownScrollView__wide: { paddingRight: size.L },
    divider: { marginVertical: size.B, marginHorizontal: size.E },
    itemWrapper: { flexDirection: 'row' }
}));
//# sourceMappingURL=List.js.map